module.exports = __webpack_public_path__ + "static/media/monday-black.030882ae.svg";